import React from "react"
import { Divider } from "@chakra-ui/core"

const BlogDivider = (): JSX.Element => {
  return <Divider borderBottom="1px solid rgba(0, 0, 0, 0.15)" />
}

export default BlogDivider
